export default "__VITE_ASSET__DUzxN4hM__"